import httpInstances from '@/api/axiosInstance';

export const getDomainConfig = (verificationToken: string) => {
  return httpInstances.axiosInternalInstance
    .get('/login/domain/config', {
      headers: { Authorization: verificationToken }
    })
    .then(res => {
      if (res.status === 200) {
        const data = res.data;
        return data;
      }
      if (res.status === 404) {
        console.error(res);
        return null;
      }
      return null;
    })
    .catch(err => {
      if (err.status === 404) {
        return null;
      }
      console.error(err);
      throw err;
    });
};
